import React, { Component } from 'react';
import StoreHeader from './../../components/StoreHeader';
import ModuleContainer from '../../components/ModuleContainer';
import Logo from '../../../includes/img/logo.png';
import { FaSyncAlt } from 'react-icons/fa';
import clearAuth from './../../../utils/clearAuth';
import {MSG_ERROR, MSG_CLICK_TRY_AGAIN} from './../../../utils/messages';
import { Button } from 'react-bootstrap';

class StoreError extends Component {


    redirectLogin = () => {
        clearAuth();
        window.location.reload();       

    }
    render() {
        return (
            <React.Fragment>
                <StoreHeader />
                <ModuleContainer>
                    <center>
                        <img alt="shsaaa-logo" src={Logo} style={{ width: 180, height: 180 }} />
                        <h2>{MSG_ERROR}</h2>
                        <div className="try-again"><Button className="refresh" onClick={() => this.redirectLogin()}><FaSyncAlt size="1em" /><h6 className="click-try">{MSG_CLICK_TRY_AGAIN}</h6></Button></div>
                    </center>
                </ModuleContainer>
            </React.Fragment>
        );
    }
}

export default StoreError;